import { EventCatalogFromKeys, EventType } from "../../../types";

export const CategoriesEventKeys = {
  ADMIN_CATEGORIES_PAGE_VIEW: "admin-categories-page-view",
  CATEGORIES_CLIENT_EXPORT: "categories-client-export",
} as const;

export const CategoriesEventCatalog: EventCatalogFromKeys<
  typeof CategoriesEventKeys
> = {
  [CategoriesEventKeys.ADMIN_CATEGORIES_PAGE_VIEW]: {
    description: "Admin viewed the categories page",
    eventType: EventType.PAGE_VIEW,
    id: CategoriesEventKeys.ADMIN_CATEGORIES_PAGE_VIEW,
  },
  [CategoriesEventKeys.CATEGORIES_CLIENT_EXPORT]: {
    description: "User exported data in CategoriesClient",
    eventType: EventType.INTERACTION,
    id: CategoriesEventKeys.CATEGORIES_CLIENT_EXPORT,
  },
};
